import { BaseApiClient } from '@/services/baseApiClient';
import type { DeleteRemoteReadingConsumptionArgs } from './types/args';
import type { DeleteRemoteReadingConsumptionResult } from './types/results';

export class RemoteReadingConsumptionApiClient extends BaseApiClient {
  constructor() {
    super('api/records/sensor/consumption');
  }

  public delete(id: DeleteRemoteReadingConsumptionArgs): Promise<DeleteRemoteReadingConsumptionResult> {
    return this.http.delete(id);
  }
}
